import Navbar from "./Navbar";
import Head from "next/head";
import { roobert, teodor } from "@/styles/font";
import Footer from "./Footer";

export function withLayout<T extends JSX.IntrinsicAttributes>(
  WrappedComponent: React.ComponentType<T>,
) {
  const ComponentWithLayout = (props: T) => {
    return (
      <div className={`${roobert.variable} ${teodor.variable}`}>
        <Head>
          <title>XQ Competency Navigator</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>

        <Navbar />
        <main>
          <WrappedComponent {...props} />
        </main>

        <Footer />
      </div>
    );
  };

  return ComponentWithLayout;
}

export default withLayout;
